import * as React from "react";
import { JSX } from "react/jsx-runtime";

const FilmIcon = ({
  color = "#fff",
  ...props
}: JSX.IntrinsicAttributes &
  React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 21"
    fill="none"
    {...props}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.499 5.846 3.386 9.95l-.738-1.97c-.247-.902.246-1.805 1.066-2.05l11.077-3.283c.903-.246 1.805.246 2.051 1.067l.657 2.133ZM6.012 5.271l2.543 3.2M11.098 3.712l2.543 3.282"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.385 9.948h14.769v6.564a1.641 1.641 0 0 1-1.641 1.641H5.026a1.64 1.64 0 0 1-1.641-1.64V9.947Z"
    />
  </svg>
);
export default FilmIcon;
